// extracted by mini-css-extract-plugin
module.exports = {"headerClassName":"styles_headerClassName__36WPR","buttonBox":"styles_buttonBox__9eBx7"};